import { cn } from "../lib/utils.js";
import "react";
import { jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { Slot } from "@radix-ui/react-slot";
//#region src/components/badge.tsx
const badgeVariants = cva(cn("tw:inline-flex tw:items-center tw:w-fit tw:overflow-hidden tw:cursor-default", "tw:px-1 tw:gap-1", "tw:text-sm tw:font-medium", "tw:rounded-xs tw:border", "tw:focus-visible:border-ring tw:focus-visible:ring-ring/50 tw:focus-visible:ring-[3px] tw:aria-invalid:ring-destructive/20 tw:dark:aria-invalid:ring-destructive/40 tw:aria-invalid:border-destructive tw:transition-[color,box-shadow]", "tw:[&>svg]:size-3 tw:[&>svg]:pointer-events-none"), {
	variants: {
		variant: {
			default: "tw:border-transparent tw:bg-primary tw:new:bg-primary-purple tw:text-white tw:[a&]:hover:bg-primary/90 tw:new:[a&]:hover:bg-primary-purple/90",
			secondary: "tw:border-transparent tw:bg-concrete/25 tw:text-midnight tw:[a&]:hover:bg-secondary/90",
			tertiary: "tw:border-transparent tw:bg-primary/10 tw:text-primary tw:new:bg-primary-lilac tw:new:text-primary-purple tw:[a&]:hover:bg-primary/20 tw:new:[a&]:hover:bg-primary-lilac/90",
			destructive: "tw:border-transparent tw:bg-secondary-clay tw:text-white tw:[a&]:hover:bg-destructive/90 tw:focus-visible:ring-destructive/20 tw:dark:focus-visible:ring-destructive/40 tw:dark:bg-destructive/60",
			outline: "tw:border-stroke tw:text-midnght tw:[a&]:hover:bg-accent tw:[a&]:hover:text-accent-foreground",
			success: "tw:border-transparent tw:bg-secondary-mint tw:text-secondary-moss tw:[a&]:hover:bg-secondary-mint/90",
			warning: "tw:border-transparent tw:bg-secondary-ivory tw:text-secondary-sand tw:[a&]:hover:bg-secondary-ivory/90"
		},
		wrap: {
			false: "tw:justify-center tw:whitespace-nowrap tw:shrink-0",
			true: "tw:justify-start tw:text-left tw:whitespace-normal tw:wrap-anywhere tw:max-w-full tw:min-w-0"
		}
	},
	defaultVariants: {
		variant: "default",
		wrap: false
	}
});
const Badge = ({ className, variant, wrap, asChild = false, ...props }) => {
	return /* @__PURE__ */ jsx(asChild ? Slot : "span", {
		"data-slot": "badge",
		className: cn(badgeVariants({
			variant,
			wrap
		}), className),
		...props
	});
};
//#endregion
export { Badge, badgeVariants };

//# sourceMappingURL=badge.js.map